import styled from 'styled-components';

export const DescriptionContainer = styled.section`
	padding: 2rem 1rem;
	line-height: 1.4;

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-size: 22px;
		font-weight: unset;
		font-variation-settings: 'wght' 550;
		margin: 15px 0 10px;
	}

	h4 {
		font-size: 20px;
	}

	h5 {
		font-size: 18px;
	}
	h6 {
		font-size: 16px;
	}

	p {
		font-variation-settings: 'wght' 350;
		margin: 0 0 20px;
		strong {
			font-variation-settings: 'wght' 650;
		}
	}

	blockquote {
		& + p {
			margin: 0 0 20px;
		}
		margin: 0 0 20px;
		padding: 15px 20px;
		border-radius: 10px;
		background-color: var(--ion-color-step-150);
		p {
			margin: 0;
		}
	}

	ul,
	ol {
		margin: 0;
		padding-left: 20px;
		margin-bottom: 20px;
		li {
			&::marker {
				color: var(--ion-color-secondary);
			}
			margin-bottom: 5px;
		}
	}
`;

export const DescriptionInner = styled.div`
	padding: 0 0.5rem 1rem;
`;

export const ToggleContainer = styled.div`
	border-bottom: 1px solid var(--ion-color-medium);
	border-top: 1px solid var(--ion-color-medium);
	padding: 10px 0;
	text-align: center;
`;

export const TextToggle = styled.a`
	display: inline-block;
	padding: 5px 15px;
	border-radius: 50px;
	font-size: 14px;
	background-color: #257226;//var(--ion-color-step-150);
	color: #ffffff;//var(--ion-color-step-750);
	opacity: 0.8;
`;
